// Load all layer images using require.context for CRA
// Returns: { back: [{id:'1', src: '...'}, ...], eyes: [...], ... }

// Cache for loaded layers
let layersCache = null;

export function loadLayers() {
  if (layersCache) {
    return layersCache;
  }

  try {
    // Load all layer images using require.context
    const layersContext = require.context('../assets/layers', true, /\.(png|jpg|jpeg|gif|webp)$/);
    
    const layers = {};
    const layerKeys = ['back', 'eyes', 'hairs', 'mouth', 'neck', 'noses'];
    
    layerKeys.forEach(layerKey => {
      layers[layerKey] = [];
      
      // Get all files in this layer folder
      const layerFiles = layersContext.keys().filter(key => key.startsWith(`./${layerKey}/`));
      
      layerFiles.forEach(filePath => {
        const fileName = filePath.split('/').pop();
        const variantId = fileName.split('.')[0]; // Remove extension
        
        layers[layerKey].push({
          id: variantId,
          src: layersContext(filePath),
          layerKey
        });
      });
      
      // Sort by ID (numeric)
      layers[layerKey].sort((a, b) => {
        const aNum = parseInt(a.id) || 0;
        const bNum = parseInt(b.id) || 0;
        return aNum - bNum;
      });
    });
    
    layersCache = layers;
    return layers;
  } catch (error) {
    console.warn('Failed to load layers:', error);
    // Fallback to empty layers
    return {
      back: [],
      eyes: [],
      hairs: [],
      mouth: [],
      neck: [],
      noses: []
    };
  }
}
